module.exports = __webpack_public_path__ + "static/28-7d6180cf316440c21e2a6fa303dfefe2.jpg";